<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesSuperioresPermanentesData"
                        :key="dente.numero"
                        position="cima"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!!item.saudeBucal.odontograma.mostrarDentesDeciduos"
            class="mt-4"
        >
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesSuperioresDeciduosData"
                        :key="dente.numero"
                        position="cima"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!!item.saudeBucal.odontograma.mostrarDentesDeciduos"
            class="mt-4"
        >
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesInferioresDeciduosData"
                        :key="dente.numero"
                        position="baixo"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-4">
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesInferioresPermanentesData"
                        :key="dente.numero"
                        position="baixo"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                A parte marcada como <span class="text-danger"><strong>vermelho</strong></span> representa não tratado.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                A parte marcada como <span class="text-primary"><strong>azul</strong></span> representa tratado.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                O ícone

                <rkm-icon
                    class="plus-icon"
                    icon="plus-circle"
                />

                representa que não há nenhum problema/condição e/ou procedimento lançado para o dente.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                O ícone

                <rkm-icon
                    class="plus-icon"
                    color="var(--success)"
                    icon="plus-circle"
                />

                representa que há ao menos um problema/condição e/ou procedimento lançado para o dente.
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import Dente from '@/components/ambulatorio/atendimento/components/soap/components/plano/components/odontograma/components/dente/Dente'

export default {
    components: {Dente},
    computed: {
        dentesSuperioresPermanentesData() {
            return this.item.saudeBucal.odontograma.arcadas.superior.dentes.permanentes
        },
        dentesSuperioresDeciduosData() {
            return this.item.saudeBucal.odontograma.arcadas.superior.dentes.deciduos
        },
        dentesInferioresDeciduosData() {
            return this.item.saudeBucal.odontograma.arcadas.inferior.dentes.deciduos
        },
        dentesInferioresPermanentesData() {
            return this.item.saudeBucal.odontograma.arcadas.inferior.dentes.permanentes
        },
    },
    methods: {
        handleDenteProps(dente) {
            return {
                disabledButton: true,
                disabledFragment: true,
                fragments: dente.fragmentos,
                iconColor: dente.problemasCondicoes.length > 0 || (dente.procedimentos && dente.procedimentos.length > 0) ? 'var(--success)' : null,
                showPopover: dente.problemasCondicoes.length > 0,
                title: dente.numero,
            }
        },
        getDentesSuperiores() {
            return this.getDentesSuperioresPermanentes().concat(this.getDentesSuperioresDeciduos())
        },
        getDentesInferiores() {
            return this.getDentesInferioresPermanentes().concat(this.getDentesInferioresDeciduos())
        },
        getDentesSuperioresPermanentes() {
            return this.item.saudeBucal.odontograma.arcadas.superior.dentes.permanentes
        },
        getDentesSuperioresDeciduos() {
            return this.item.saudeBucal.odontograma.arcadas.superior.dentes.deciduos
        },
        getDentesInferioresDeciduos() {
            return this.item.saudeBucal.odontograma.arcadas.inferior.dentes.deciduos
        },
        getDentesInferioresPermanentes() {
            return this.item.saudeBucal.odontograma.arcadas.inferior.dentes.permanentes
        },
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>